import Vue from 'vue'
import foreignRadio from './foreign-base-radio/foreign-base-radio'
import foreignSelect from './foreign-base-select/foreign-base-select'
import imgUpload from '@/components/upload/img-upload'
import fileUpload from '@/components/upload/file-upload'
import fileUploadNew from '@/components/upload/file-upload-new'
import selectCompany from './select-components/select-company'
import foreignDatePicker from "./foreign-date-picker"
//此项目由于历史原因 elementUI版本较低 cascader组件的多选功能不可用 为免UI框架升级可能造成其他正常功能受到影响 
//故把新版本的elementUI中的cascader组件抽离出来并作为全局组件引入
import ELCascaderMultiple from '@/components/element-ui-cascader-multiple/cascader';
Vue.component('foreignRadio', foreignRadio)
Vue.component('foreignSelect', foreignSelect)
Vue.component('imgUpload', imgUpload)
Vue.component('fileUpload', fileUpload)
Vue.component('fileUploadNew', fileUploadNew)
Vue.component('selectCompany', selectCompany)
Vue.component('foreignDatePicker', foreignDatePicker)
Vue.component('cascaderMultiple', ELCascaderMultiple)
